export const min1024pxWideMediaQuery = (): MediaQueryList =>
  window.matchMedia('only screen and (min-width: 1024px)');
export const isMin1024pxWide = (): boolean => min1024pxWideMediaQuery().matches;

export const isMin768pxWideMediaQuery = (): MediaQueryList =>
  window.matchMedia('only screen and (min-width: 768px)');
export const isMin768pxWide = (): boolean => isMin768pxWideMediaQuery().matches;

export const touchMediaQuery = (): MediaQueryList =>
  window.matchMedia('(pointer: coarse)');
export const isTouchDevice = (): boolean => touchMediaQuery().matches;

const tabletPortraitMediaQuery = (): MediaQueryList =>
  window.matchMedia(
    'only screen and (min-width: 768px) and (max-width: 1023px) and (pointer: coarse)'
  );
export const isTabletPortrait = (): boolean =>
  tabletPortraitMediaQuery().matches;

export const addMediaQueryListener = (callback: () => void): (() => void) => {
  const mediaQuery = tabletPortraitMediaQuery();

  const handler = (e: MediaQueryListEvent): void => {
    if (e.matches === false) {
      callback();
    }
  };

  // Check if addEventListener is supported (modern browsers)
  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', handler, { once: true });

    return (): void => {
      mediaQuery.removeEventListener('change', handler);
    };
  } else {
    // Fallback for Safari 13 and older browsers
    const onceHandler = (e: MediaQueryListEvent): void => {
      handler(e);
      mediaQuery.removeListener(onceHandler);
    };

    mediaQuery.addListener(onceHandler);

    return (): void => {
      mediaQuery.removeListener(onceHandler);
    };
  }
};
